<p-accordion (onOpen)="open($event)" (onClose)="close($event)">
  <p-accordionTab header="Settings" [headerStyleClass]="'py-1'">
    @if (isPartnerPortal) {
      <div class="text-start mt-2">
        <label class="d-block">{{"Store"|translate}}</label>
        <select class="form-control d-block" [(ngModel)]="storeName" (change)="setStore()">
          <option value="default">Default</option>
          <option value="raleigh">Raleigh</option>
          <option value="wipro">Wipro</option>
        </select>
      </div>
    }
  </p-accordionTab>
  <div class="d-flex align-items-center">
    <p-inputSwitch class="mt-1 me-1" inputId="customTheme" (onChange)="saveSettings(true)"
    [(ngModel)]="customTheme"></p-inputSwitch>
    <label>Black Friday theme</label>
  </div>
  <div class="d-flex align-items-center">
    <p-inputSwitch class="mt-1 me-1" inputId="basketFrequency" (onChange)="saveSettings(true)"
    [(ngModel)]="basketFrequency"></p-inputSwitch>
    <label>Basket Frequency</label>
  </div>
  @if (isAdmin) {
    <p-accordionTab header="Index information" [headerStyleClass]="'py-1'">
      @if (indexData === null) {
        <span class="ms-2 spinner-border spinner-border-sm d-inline-block" role="status" aria-hidden="true"></span>
      }
      @if (indexData !== null && tabIndex === 1) {
        <table class="table table-bordered table-striped text-start">
          <tbody>
            <tr>
              <td>Creating index:</td>
              <td>{{indexData.creating_index}}</td>
            </tr>
            <tr>
              <td>Index name:</td>
              <td>{{indexData.index_name}}</td>
            </tr>
            <tr>
              <td>PIM parser busy:</td>
              <td>{{indexData.pim_parser_busy}}</td>
            </tr>
            <tr>
              <td>PIM parser invalid msg:</td>
              <td>{{indexData.pim_parser_invalid_data_message}}</td>
            </tr>
            <tr>
              <td>PIM parser last run:</td>
              <td>{{lastRun}}</td>
            </tr>
            <tr>
              <td>PIM parser valid data:</td>
              <td>{{indexData.pim_parser_valid_data}}</td>
            </tr>
            <tr>
              <td>Recent index:</td>
              <td>{{indexData.recent_index}}</td>
            </tr>
            <tr>
              <td>Recent PIM update:</td>
              <td>{{indexData.recent_pim_update}}</td>
            </tr>
          </tbody>
        </table>
      }
    </p-accordionTab>
  }
</p-accordion>
